module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.forecast) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('DefaultButton', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        _vm.$router.push(((_vm.ROUTES.BASE) + "/" + _vm.forecastId))
      }
    }
  }, [_vm._v("« Back")]), _vm._v(" "), _c('ForecastNameBanner', {
    attrs: {
      "forecast": _vm.forecast
    }
  }), _vm._v(" "), _c('ForecastInfos', {
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "forecast": _vm.forecast
    }
  }), _vm._v(" "), _c('CalendarInfo', {
    attrs: {
      "forecast": _vm.forecast
    }
  }), _vm._v(" "), _c('Comments', {
    attrs: {
      "forecast": _vm.forecast
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title SectionBorderTop"
  }, [_vm._v("Secondary Window Dates")]), _vm._v(" "), (_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "forecast-windows"
  }, [_c('SecondaryWindowForm', {
    attrs: {
      "forecast-window": _vm.defaultForecastWindow,
      "min": _vm.forecast.startDate,
      "max": _vm.forecast.endDate,
      "is-default": true,
      "is-apply-disabled": _vm.selectedForecastWindows.length === 0
    },
    on: {
      "applyDefault": _vm.applyDefault
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1",
    staticStyle: {
      "margin-top": "auto",
      "text-align": "center"
    }
  }, [_c('ClientColorButton', {
    attrs: {
      "size": 'xs',
      "disabled": _vm.selectedForecastWindows.length === _vm.forecastWindows.length
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("Select All")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('ClientColorButton', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.selectedForecastWindows.length === 0
    },
    on: {
      "click": _vm.publishSelected
    }
  }, [_vm._v("Publish selected")])], 1)]), _vm._v(" "), _vm._l((_vm.forecastWindows), function(fcw, index) {
    return _c('div', {
      key: fcw.id,
      staticClass: "forecast-windows"
    }, [_c('SecondaryWindowForm', {
      attrs: {
        "forecast-window": fcw,
        "min": _vm.forecast.startDate,
        "max": _vm.forecast.endDate,
        "index": index,
        "is-selected": _vm.selectedForecastWindows.some(function (fw) { return fw.id === fcw.id; }),
        "is-valid": _vm.isValid(fcw)
      },
      on: {
        "published": _vm.fetchForecastWindows,
        "toggleSelect": function($event) {
          _vm.toggleSelect(fcw)
        }
      }
    })], 1)
  })], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("Start date*")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("End date*")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_vm._v("Reminder*")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_vm._v("Message / Recommendations")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4078e96d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/ForecastSecondaryWindow.vue
// module id = 3141
// module chunks = 0